import * as React from "react";
import moment from "moment";
import * as _ from "lodash";
import { Row, Col, Typography, Grid } from "antd";

import { DAY, Epoch, FORTNIGHT } from "@ctra/utils";
import styles from "./Period.module.less";

const { Text } = Typography;

export interface PeriodProps {
  /**
   * Start date (as epoch)
   */
  startEpoch: number;
  /**
   * End date (as epoch)
   */
  endEpoch: number;
  /**
   * Current date (as epoch)
   */
  now?: number;
  /**
   * Days remaining
   */
  untill: string;
}

/**
 * Period indicator for game plans
 * @constructor
 */
const Period: React.FC<PeriodProps> = ({ untill, ...props }) => {
  const { md } = Grid.useBreakpoint();
  /**
   * Convert ms epoch values to internal format
   */
  const {
    startEpoch,
    endEpoch,
    now = Epoch.load(+moment())
  } = _.mapValues(props, Epoch.load) as unknown as PeriodProps;

  /**
   * Calculate the progress
   */
  const progress = Math.min((now - startEpoch) / (endEpoch - startEpoch), 1) * 100;

  /**
   * The number of days until the deadline
   */
  const daysUntilDeadline = Epoch.daysBetween(Epoch.now(), endEpoch);

  /**
   * Tell if the game plan is past
   */
  const ended = daysUntilDeadline <= 0;

  /**
   * The game plan ends when there is less than 2 weeks left
   */
  const endingSoon = !ended && daysUntilDeadline * DAY < FORTNIGHT;

  /**
   * Render a localised date from the given epoch
   * @param epoch
   */
  const renderDate = (epoch: number) => {
    return Epoch.asMoment(epoch).format("L");
  };

  return (
    <Row gutter={[0, 16]}>
      <Col span={24} className={styles.Slider}>
        <div className={styles.Progress} style={{ width: `${progress}%` }} />
      </Col>
      <Col style={md ? {} : { margin: "auto" }}>
        <Text className={styles.Date} type={endingSoon ? "danger" : "secondary"}>
          {ended ? (
            <>
              {renderDate(startEpoch)} - {renderDate(endEpoch)}
            </>
          ) : (
            untill
          )}
        </Text>
      </Col>
    </Row>
  );
};

export default Period;
